export default __webpack_public_path__ + "static/media/FerrariBackground.73d72b81.jpg";